import { memo } from 'react';
import { PreferenceEnumType, PreferenceOption } from '@mark43/cad-api';
import { VStack, Text } from '@cad-arc';
import { FormCheckbox } from '../forms/integrated-form-controls/form-checkbox';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { PreferencesFormType } from './types';
import { DEPENDENT_PREFERENCES } from './constants';

export const PreferencesModalSection = memo(function CadPreferencesModalSection({
    title,
    fields,
    preferencesToDisplay,
    isFieldEnabled,
    onClickPreference,
    testId,
}: {
    title: string;
    fields: PreferenceOption[];
    preferencesToDisplay: string[];
    isFieldEnabled: (preference: PreferenceEnumType) => boolean | undefined;
    onClickPreference: (preference: PreferenceEnumType) => void;
    testId: string;
}) {
    const { form } = useIntegratedForm<PreferencesFormType>();

    return (
        <VStack alignItems="flex-start" data-testid={testId}>
            <Text fontSize="sm" color="tertiary" as="b">
                {title}
            </Text>
            {fields.map((field, index) =>
                preferencesToDisplay.includes(field.preference) ? (
                    <FormCheckbox
                        key={field.preference}
                        label={field.label}
                        name={`preferences.${index}.value`}
                        control={form.control}
                        onChange={() => {
                            onClickPreference(field.preference);
                        }}
                        isDisabled={!isFieldEnabled(field.preference)}
                        {...(DEPENDENT_PREFERENCES.includes(field.preference)
                            ? {
                                  checkboxProps: {
                                      style: {
                                          marginLeft: 25,
                                      },
                                  },
                              }
                            : {})}
                    />
                ) : null
            )}
        </VStack>
    );
});
